export default __webpack_public_path__ + "./font/eda855833c75e50e5ca2678f7c3a74ef.woff2";